import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentSearchComponent } from './student-search/student-search.component';
import { StudentDetailComponent } from './student-detail/student-detail.component';
import { DialpadComponent } from './dialpad/dialpad.component';
import { AppComponent } from './app.component';
import { GenesysLoginComponent } from './genesys-login/genesys-login.component';
import { AzureLoginComponent } from './azure-login/azure-login.component';
import { SequentialGuard } from './login-action/sequential.guard';
import { ChatComponent } from './sms/chat/chat.component';
import { AdmissionUiComponent } from './admission-ui/admission-ui.component';

const routes: Routes = [
  {
    path: "",
    component: AppComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: "dial",
    component: DialpadComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: 'student',
    component: StudentSearchComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: 'student/:id', component: StudentDetailComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: 'genesys',
    component: GenesysLoginComponent,
    canActivate: []
  },
  {
    path: 'azuread',
    component: AzureLoginComponent,
    canActivate: []
  },
  {
    path: 'sms', component: ChatComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: 'sms/:syStudentId', component: ChatComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: 'leadui/idle', component: AdmissionUiComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: 'leadui/email/:emailId', component: AdmissionUiComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: 'leadui/inbound/:conversationId/:phoneNumber', component: AdmissionUiComponent,
    canActivate: [SequentialGuard]
  },
  {
    path: 'leadui/outbound/:phoneNumber', component: AdmissionUiComponent,
    canActivate: [SequentialGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // do not change this, iFrame apps will break
    initialNavigation: "enabledNonBlocking",
    enableTracing: false
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
